module.exports = __webpack_public_path__ + "img/serveContent4.0b66a2f7.png";